module.exports = __webpack_public_path__ + "img/img_login_person1.18337e3f.png";